module.exports = __webpack_public_path__ + "static/media/mobileapp.1c8099ed.mp4";